import { connect } from 'react-redux';
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';

import { NewSubpatientFormContainer } from './NewSubpatientFormContainer';

const ConnectedForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(NewSubpatientFormContainer);

export { ConnectedForm as NewSubpatientForm };
